import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const DetailsList = ({ details }) => {
  if (!details) {
    return null;
  }

  return (
    <div>
      {details.map(({ name, value }, i) => (
        <div
          className={classnames('subscription-modal__details', {
            'subscription-modal__details--border-top': i > 0,
            'subscription-modal__details--padding-top': i === 0,
          })}
          key={i}
        >
          <div className="subscription-modal__details-name">{name}</div>
          <div className="subscription-modal__details-value">{value}</div>
        </div>
      ))}
    </div>
  );
};

DetailsList.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    }),
  ).isRequired,
};
